/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React from "react"

/* ====== CSS ====== */
import styled from 'styled-components';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ アイコン ------*/
const SdivIconWrapper = styled.div`//アイコン枠
display: flex;
height: 27px;
`;
const SdivLeft = styled.div`//左側アイコン
width: 1.5px;
background-color: #2E94B9;
`;
const SdivRight = styled.div`//右側アイコン
width: 3.5px;
margin-left: 3px;
margin-right: 5px;
background-color: #2E94B9;
`;

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  
export const SubtitleIcon = (props) => {

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
        return(
        <>
            <SdivIconWrapper>
                <SdivLeft />
                <SdivRight />
            </SdivIconWrapper>
        </>
    )
}